<template>
    <ProgressBar
        v-if="(row?.MaxContestants ?? 0) > 0"
        :value="value"
        :maxValue="row!.MaxContestants!"
        type="dynamicinverse"
    />
    <span
        v-else
        class="text-end"
        >{{ value }}</span
    >
</template>

<script lang="ts" setup>
/**
 * Component to show the number of contestants compared to the max number of contestants as a progress bar.
 */
import type { GroupWithCount } from '@/objects/generated';
import { ProgressBar } from '@/components';

defineProps<{
    /**
     * The value to display.
     */
    value: number;

    /**
     * The row
     */
    row?: GroupWithCount;
}>();
</script>
